import { List, ListItem, Tooltip } from "@mui/material";
import { HelpOutline } from "@mui/icons-material";
import styles from "./SkillsInterestsList.module.scss";

interface NestedItem {
  id: string | number;
  name: string;
}

interface MappedItem {
  name: string;
  nestedItems: NestedItem[];
}

interface SkillsInterestsListViewProps {
  items?: MappedItem[];
  title?: string;
  emptyMessage?: string;
}

/**
 * Pure presentational component for displaying a list of items with nested sub-items
 * 
 * @param items - Array of already mapped objects: [{ name: string, nestedItems: [{ name: string, id: string }] }]
 * @param title - Optional title to display above the list
 * @param emptyMessage - Optional message when list is empty
 */
export const SkillsInterestsListView = ({ 
  items = [], 
  title,
  emptyMessage
}: SkillsInterestsListViewProps) => {
  // Return null or empty message if no items
  if (!items || items.length === 0) {
    if (emptyMessage) {
      return (
        <div className={styles.empty}>
          <p>{emptyMessage}</p>
        </div>
      );
    }
    return null;
  }

  return (
    <div className={styles.container}>
      {title && <h2 className={styles.title}>{title}</h2>}
      <List className={styles.list}>
        {items.map((item, idx) => {
          // Create tooltip content from nested items
          const tooltipContent = item.nestedItems && item.nestedItems.length > 0 ? (
            <ul className={styles.tooltipList}>
              {item.nestedItems.map((subItem) => (
                <li key={subItem.id}>
                  {subItem.name}
                </li>
              ))}
            </ul>
          ) : null;

          return (
            <ListItem key={idx} disablePadding className={styles.item}>
              <Tooltip 
                title={tooltipContent || ""} 
                arrow 
                placement="top"
                enterDelay={300}
                classes={{ tooltip: styles.tooltip }}
              >
                <div className={styles.categoryName}>
                  <span className={styles.categoryText}>{item.name}</span>
                  <HelpOutline className={styles.helpIcon} />
                </div>
              </Tooltip>
            </ListItem>
          );
        })}
      </List>
    </div>
  );
};

